export default __webpack_public_path__ + "static/media/james.2697226e.jpg";